import BaseTeamApi from "../BaseTeamApi";

export default abstract class BaseProjectTeamIdApi extends BaseTeamApi {
	protected override getBaseUrl(params: Record<string, string>) {
		return `${super.getBaseUrl(params)}/${params["projectTeamId"]}`;
	}
}
